// extracted by mini-css-extract-plugin
export default {"media":"index_media_q7UiE","mediaVideo":"index_mediaVideo_6gXp8","mediaPic":"index_mediaPic_BdHsr"};